import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getLocaleFromPathname } from '../config/localeRoutes';
import './HomeContentExplore.css';

const FR_EXPLORE_LINKS = [
  { to: '/solutions/', labelKey: 'homeExplore.solutions' },
  { to: '/secteurs/', labelKey: 'homeExplore.sectors' },
  { to: '/comparatifs/', labelKey: 'homeExplore.comparisons' },
  { to: '/articles/', labelKey: 'homeExplore.articles' },
];

const EN_EXPLORE_LINKS = [
  { to: '/en/solutions/', labelKey: 'homeExplore.solutions' },
  { to: '/en/comparisons/', labelKey: 'homeExplore.comparisons' },
  { to: '/en/webrtc-video-infrastructure/', labelKey: 'homeExplore.enWebrtc' },
  { to: '/en/gdpr-video-compliance/', labelKey: 'homeExplore.enGdpr' },
  { to: '/en/zoom-alternative-eu/', labelKey: 'homeExplore.enZoomAlt' },
  { to: '/en/quote/', labelKey: 'homeExplore.enQuote' },
];

function HomeContentExplore() {
  const { t } = useTranslation();
  const location = useLocation();
  const locale = getLocaleFromPathname(location.pathname);
  const links = locale === 'en' ? EN_EXPLORE_LINKS : FR_EXPLORE_LINKS;

  return (
    <section className="home-content-explore section" aria-labelledby="home-explore-title">
      <div className="container">
        <h2 id="home-explore-title" className="section-title">
          {t('homeExplore.title')}
        </h2>
        <p className="section-quick-answer">{t('homeExplore.quickAnswer')}</p>
        <ul className="home-content-explore-links">
          {links.map((link) => (
            <li key={link.to}>
              <Link to={link.to}>{t(link.labelKey)}</Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

export default HomeContentExplore;
